
    import { ModalBeforeOpenEvent } from '@/models/Interfaces';
    import SelectOption from '@/models/SelectOption';
    import { SMSsHistoryFilter, EmailSMSTemplateRowResource } from '@/models/SMS';
    import _ from 'lodash';
    import { Options, Vue } from 'vue-class-component';
    import MessageBlock from '@/components/Helpers/MessageBlock.vue';
    import Swal from 'sweetalert2';
    import { api } from '@/services/Api';

    export type OnSaveCallback = (filter: SMSsHistoryFilter) => void;

    @Options<FilterModal>({
        props: {
            name: String,
        },
        components: {
            MessageBlock,
        },
    })
    export default class FilterModal extends Vue {
        private readonly name!: string;
        public SmsTemplates!: SelectOption[];
        public filter: SMSsHistoryFilter = new SMSsHistoryFilter();
        public templateId: string = '';
        public newTemplate: EmailSMSTemplateRowResource = new EmailSMSTemplateRowResource();
        public isTemplateUsed: boolean = false;
        public onSave: OnSaveCallback | null = null;
        public id: string | null = null;
        public async beforeOpen(event: ModalBeforeOpenEvent) {
            this.id = event.params?.id || null;
            if (this.id !== null) {
                var resp = await api.SMSGetTemplate(this.id);
                if (resp.Error || resp.Data == null) {
                    Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                    return;
                }
                this.newTemplate = resp.Data.SmsTemplate;
                this.isTemplateUsed = resp.Data.IsUsed;
            } else {
                this.newTemplate = new EmailSMSTemplateRowResource();
            }
            this.filter = event.params.incomeFilter ? event.params.incomeFilter : new SMSsHistoryFilter();
            if (this.SmsTemplates && this.filter.Keywords) {
                const foundId = this.SmsTemplates.find((x) => x.text === this.filter.Keywords)?.id.toString();
                if (foundId) {
                    this.templateId = foundId;
                } else {
                    this.templateId = '';
                }
            }
            this.onSave = event.params?.onSave || null;
        }
        public async saveFilter() {
            if (this.onSave) {
                this.onSave(this.filter);
            }
        }

        public async modalSearch() {
            if (!this.newTemplate.Name) {
                Swal.fire({
                    icon: 'error',
                    text: this.$t('page.sms-list.history-tab.newTemplate.alert.nameRequired') as string,
                });
                return;
            }
            if (this.isTemplateUsed) {
                const opts: any = new Promise((resolve) => {
                    resolve({
                        1: this.$t('page.sms-template.alert.optionTemplateOnly'),
                        2: this.$t('page.sms-template.alert.optionTemplateAndSchedul'),
                    });
                });

                const confirmation = await Swal.fire({
                    title: this.$t('page.sms-template.alert.title') as string,
                    input: 'radio',
                    inputOptions: opts,
                    showCancelButton: true,
                    confirmButtonText: this.$t('page.automations.actions.continue') as string,
                    cancelButtonText: this.$t('modal.button.cancel') as string,
                });
                if (confirmation.isDismissed) {
                    return;
                }
                if (!confirmation.value) {
                    Swal.fire({
                        icon: 'error',
                        text: this.$t('page.sms-template.alert.error') as string,
                    });
                    return;
                }
                if (confirmation.value === '2') {
                    this.newTemplate.ChangeBoth = true;
                }
            }
            var resp = await api.SMSSaveTemplate(this.newTemplate);
            if (resp.Error || !resp.Data) {
                Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                return;
            }
            this.saveFilter();
            this.$emit('onCreateSmsTemplate');
        }
    }
